import {Configuration, BrowserCacheLocation, LogLevel} from '@azure/msal-browser';
import {environment} from "../environments/environment";

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.config.clientId,
    authority: `https://login.microsoftonline.com/${environment.config.tenant}`,
    redirectUri: environment.config.redirectUri,
    postLogoutRedirectUri: environment.config.postLogoutRedirectUri
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      logLevel: environment.config.LOGGING_LEVEL as LogLevel,
      piiLoggingEnabled: false,
      loggerCallback: (level: LogLevel, message: string) => {
        switch (level) {
          case LogLevel.Error:   console.error(message); break;
          case LogLevel.Warning: console.warn(message);  break;
          case LogLevel.Info:    console.info(message);  break;
          case LogLevel.Verbose: console.debug(message); break;
        }
      }
    }
  }
};

/**
 * Protected backend API configuration
 * MSAL interceptor will attach access tokens to this endpoint
 */
export const protectedResources = {
  api: {
    endpoint: environment.apiEndPoint,
    scopes: [`${environment.apiAppId}`]
  }
};
